import React from "react"
import SummaryTable from "components/Transactional/Performance/components/SummaryTable"
import SummaryTableSkeleton from "components/Transactional/Performance/components/SummaryTable/SummaryTableSkeleton/SummaryTableSkeleton"
import withVisibility from "components/Shared/Hocs/withVisibility"
import { useGetPenetrationSummary } from "components/Transactional/Performance/hooks/useGetPenetrationSummary"
import { PenetrationSummaryFilters } from "components/Transactional/Performance/interfaces"
import { RequestHandler } from "components/Shared/RequestHandler"
import { SummaryPenetration } from "components/Transactional/Performance/components/SummaryTable/SummaryTable.domain"
import { PENETRATION } from "./constants"

interface PenetrationSummaryProps {
	filtersBenchmark: PenetrationSummaryFilters
	summaryPenetrationType: string
}

const DEFAULT_DATA = {
	commercialBenchmarkVsm: [],
}

const PenetrationSummary: React.FC<PenetrationSummaryProps> = (props) => {
	const { filtersBenchmark, summaryPenetrationType } = props

	const {
		reachData = DEFAULT_DATA,
		isLoading,
		isError,
		error,
		refetch,
	} = useGetPenetrationSummary(
		filtersBenchmark,
		`${PENETRATION}_${summaryPenetrationType}`
	)

	return (
		<RequestHandler
			hasData={Boolean(reachData?.commercialBenchmarkVsm)}
			isLoading={isLoading}
			isError={isError}
			error={error}
			retry={refetch}
			skeleton={<SummaryTableSkeleton iterate={2} type={"donut"} />}
		>
			{reachData?.commercialBenchmarkVsm?.map((node) => (
				<SummaryTable
					key={node.identifierName}
					type={node.identifierName as SummaryPenetration}
					data={node.commercialBenchmarkVsmDetails}
					summaryPenetrationType={summaryPenetrationType}
				/>
			))}
		</RequestHandler>
	)
}

export default withVisibility(PenetrationSummary)
